import { useEffect, useState } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import { useRecoilState } from "recoil";
import { tokenState } from "../../../atoms/token";
import { userState } from "../../../atoms/user";
import { info } from "console";
import { title } from "process";
import './style.scss';
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";

const TicRequests = () => {
  const { user } = useAuth();

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [token] = useRecoilState(tokenState);
  const [userInfo, setuserInfo] = useRecoilState(userState);
  const [ticRequests, setTicRequests] = useState([]);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('searc state', state);
    console.log('use ef rows', selectedRows);
    getRequestedTicNumbers();
    setReload(false);
  }, [reload]);

  const getRequestedTicNumbers = async () => { 
    const url = `${environment.npgAPI}etic/getAssignedTicNumbers?currentPage=1&pageSize=20000&userid=${userInfo?.userId}`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('tics', res);
      let sorted = res.data.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
      setTicRequests(sorted);
      setLoading(false);
      console.log('ticRequests', ticRequests);
    });
  }
 
  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'TIC#', width: 200 },
    { field: 'parkCode', headerName: 'Park Code', width: 200 },
    { field: 'parkName', headerName: 'Park Name', width: 300 },
    { field: 'createdDate', headerName: 'Create Date', width: 200 },
    { field: 'title', headerName: 'Title', width: 200 },
    { field: 'pmisNumber', headerName: 'PMIS', width: 100 },
    { field: 'comments', headerName: 'Comments', width: 300 }
  ];
  
  return (
    <>
    <h1 className="center">Requested TIC Numbers</h1>
    <h2 className="center">{user?.profile?.name}</h2>
      <div className="search-results">
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={ticRequests.map((result, index) => (
              {
                comments: result?.comments,
                parkCode: result?.parkCode,
                parkName: result?.parkName,
                email: result?.email,
                name: result?.lastName + ' ' + result?.firstName,
                id: result?.ticNumber,
                infoType: result?.infoType,
                parkAlpha: result?.parkAlpha,
                parkId: result?.parkId,
                pmisNumber: result?.pmisNumber,
                title: result?.title,
                createdDate: formatDate(result?.createdDate),
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            
            loading={loading}
          />
        </div>
      </div>
    </>
  );
}

export default TicRequests;